import React from "react";
import "./Sidebar.css"; // 共用 modal 樣式

const UpgradeModal = ({ onClose }) => {
  const options = [
    { title: "一般會員", desc: "享有基本發文功能", features: ["每天可發表 1 篇文章"] },
    { title: "特級會員", desc: "進階功能解鎖", features: ["可發表無限篇文章", "可上傳高畫質圖片"] },
    { title: "合作夥伴", desc: "商業合作與推廣", features: ["自訂品牌頁", "後台數據分析"] },
  ];

  return (
    <div className="upgrade-modal-backdrop" onClick={onClose}>
      <div className="upgrade-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>✖</button>
        <h2 className="upgrade-modal-title">升級會員</h2>
        <p className="upgrade-modal-subtitle">選擇最適合你的會員方案</p>
        <div className="membership-options">
          {options.map((opt, index) => (
            <div className="membership-card" key={index}>
              <h3>{opt.title}</h3>
              <p>{opt.desc}</p>
              <ul>
                {opt.features.map((f, idx) => <li key={idx}>{f}</li>)}
              </ul>
              <button onClick={() => alert(`你選擇了「${opt.title}」`)}>立即升級</button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UpgradeModal;